export class LocalStorageManager {
  static customerIDScope = 'CustomerID_Scope'
  static plantIDScope = 'PlantID_Scope'

  static getLocalCustomerIDScope(): number | null {
    return Number(localStorage.getItem(LocalStorageManager.customerIDScope))
  }

  static setLocalCustomerIDScope(customerID: number | null): void {
    if (customerID == null) {
      localStorage.removeItem(LocalStorageManager.customerIDScope)
      return
    }

    localStorage.setItem(
      LocalStorageManager.customerIDScope,
      customerID.toString()
    )
  }

  static getLocalPlantIDScope(): Set<number> | null {
    const value = localStorage.getItem(LocalStorageManager.plantIDScope)
    if (!value) {
      return new Set()
    }

    const parsed = JSON.parse(value)
    return new Set(parsed)
  }

  static setLocalPlantIDScope(plantIDs: number[] | Set<number> | null): void {
    if (plantIDs == null) {
      localStorage.removeItem(LocalStorageManager.plantIDScope)
      return
    }

    const filteredPlantIDs = Array.from(plantIDs).filter(p => p != null)

    if (filteredPlantIDs.length === 0) {
      localStorage.removeItem(LocalStorageManager.plantIDScope)
      return
    }

    localStorage.setItem(
      LocalStorageManager.plantIDScope,
      JSON.stringify(filteredPlantIDs)
    )
  }
}
